import React from 'react';

import { HeroLocation } from '../../index';
import { useSiteQuery } from '../../../hooks';

import query from './index.graphql';

interface Props {
  title: string;
  headline: string;
  photos: AssetFragment[];
  onGalleryClick: (e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => void;
  location: string;
  activities?: Maybe<Array<Maybe<{ title?: string | null }>>>;
  additionalClasses?: string | null;
  consultant?: Maybe<ConsultantsFragment>[] | ConsultantsFragment;
  hideContactCtas?: boolean | null;
}

const Headings = ({ title, headline, photos, location, activities, consultant, hideContactCtas }: Props) => {
  useSiteQuery<UnitsQuery>({ query, variables: { location } });

  return (
    <HeroLocation
      sectionHeading="Retirement Village Locations"
      title={title}
      headline={headline}
      photos={photos}
      additionalClasses={'override-bg-blue-signature'}
      isRetirementVillage={true}
      activities={activities}
      consultant={consultant}
      locationTitle={title}
      hideContactCtas={hideContactCtas}
    />
  );
};

export default Headings;
